import { Checkbox, Fieldset, TextField, PhoneInput } from '@servicetitan/anvil2-react-hook-form';
import { SetupDataStore, useProviderConfig } from '@servicetitan/financing-workflow-shared';
import { MailingAddressFields } from '../mailing-address/MailingAddressFields';
import { getProviderValidation } from './providerValidations';

interface ExternalApplicationFieldsProps {
    isPrequalification?: boolean;
}

export const ExternalApplicationFields = ({
    isPrequalification = false,
}: ExternalApplicationFieldsProps) => {
    const { applicationAcknowledgementText, prequalAcknowledgementText, showAddressFields } =
        useProviderConfig();
    const { setupData } = SetupDataStore.useStore();
    const providerValidation = getProviderValidation(setupData?.provider);

    return (
        <Fieldset>
            <TextField
                name="firstName"
                label="First Name"
                required
                maxLength={providerValidation?.firstName?.maxLength}
            />
            <TextField
                name="lastName"
                label="Last Name"
                required
                maxLength={providerValidation?.lastName?.maxLength}
            />
            <TextField name="email" label="Email Address" inputMode="email" required />
            <PhoneInput name="primaryPhone" label="Phone Number" required />
            {isPrequalification && (
                <TextField
                    name="ssnLast4"
                    label="Last 4 Digits of Social Security Number"
                    required
                    maxLength={4}
                    pattern="[0-9]*"
                    inputMode="numeric"
                />
            )}
            {showAddressFields && <MailingAddressFields />}
            {(applicationAcknowledgementText ?? prequalAcknowledgementText) && (
                <Checkbox
                    name="applicationAcknowledgement"
                    label={
                        (isPrequalification ? prequalAcknowledgementText : undefined) ??
                        applicationAcknowledgementText ??
                        ''
                    }
                    defaultChecked={false}
                    required
                />
            )}
        </Fieldset>
    );
};
